import { Box, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import { signatureBase64ToDataUrl } from '../utils/signature';

export const FormSignature: React.FC<{ signatureBase64: string }> = ({ signatureBase64 }) => {
  const theme = useTheme();
  const dataUrl = signatureBase64ToDataUrl(signatureBase64);

  if (!dataUrl) {
    return null;
  }

  return (
    <Box>
      <Box display="flex" flexDirection="column" gridGap={12}>
        <Typography variant="subtitle1" color="textPrimary">
          Signature
        </Typography>
        <Box
          justifyContent="center"
          alignItems="center"
          display="flex"
          style={{
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: 8,
            padding: 16,
            minHeight: 120,
          }}
        >
          <img src={dataUrl} alt="Signature" style={{ maxWidth: '100%', maxHeight: 200 }} />
        </Box>
      </Box>
    </Box>
  );
};
